module.exports = __webpack_public_path__ + "static/media/genesis_logo_transparent.57130180.png";